// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Checkbox from 'components/form/checkbox'

// Redux:
import { acceptCatCheck, acceptDogCheck } from 'actions/site'
import { lastSelectedAnimal } from 'selectors/animals'

class ApplyButton extends React.Component {
	constructor( props ) {
		super( props )

		let data = props.lastSelectedAnimal,
			savedData = false

		if ( ! data ) {
			savedData = JSON.parse( localStorage.getItem( 'lastSelectedAnimal' ) )
		}

		if ( savedData ) {
			data = savedData
		}

		this.state = {
			data: data,
			cats_accept_checkbox: false,
			dogs_accept_checkbox: false
		}

		this.update()
	}

	componentDidUpdate( prevProps ) {
		const { lastSelectedAnimal } = this.props

		if ( lastSelectedAnimal != prevProps.lastSelectedAnimal ) {
			this.update()
		}
	}

	update = () => {
		const { lastSelectedAnimal } = this.props

		if ( lastSelectedAnimal ) {
			localStorage.setItem( 'lastSelectedAnimal', JSON.stringify( lastSelectedAnimal ) )

			this.setState( {
				data: lastSelectedAnimal
			} )
		}
	}

	handleCatsAcceptCheckboxChange = ( id, value ) => {
		this.setState( {
			cats_accept_checkbox: value
		} )
	}

	handleDogsAcceptCheckboxChange = ( id, value ) => {
		this.setState( {
			dogs_accept_checkbox: value
		} )
	}

	renderCatsCheck = () => {
		const { allPages } = this.props
		const { cats_accept_checkbox } = this.state

		if ( ! allPages || ! allPages['id_responsible-containment'] ) {
			return null
		}

		const pageData = allPages['id_responsible-containment']

		return (
			<div className="content-body-wrap terms-acceptance">
				<div className="content-body-full">
					<div className="content-body-text">
						<div dangerouslySetInnerHTML={ { __html: pageData.content.rendered } }></div>

						<br /><br />

						<Checkbox
							id="cats_accept"
							label="I understand and agree to adhere to responsible containment practices"
							value={ cats_accept_checkbox }
							onChange={ this.handleCatsAcceptCheckboxChange }
						/>
					</div>
				</div>
			</div>
		)
	}

	renderDogsCheck = () => {
		const { allPages } = this.props
		const { dogs_accept_checkbox } = this.state

		if ( ! allPages || ! allPages['id_ehrlichiosis'] ) {
			return null
		}

		const pageData = allPages['id_ehrlichiosis']

		return (
			<div className="content-body-wrap terms-acceptance">
				<div className="content-body-full">
					<div className="content-body-text">
						<div dangerouslySetInnerHTML={ { __html: pageData.content.rendered } }></div>

						<br /><br />

						<div className="callout">
							<Checkbox
								id="dogs_accept"
								label="I have read and understood the above information about Ehrlichiosis"
								value={ dogs_accept_checkbox }
								onChange={ this.handleDogsAcceptCheckboxChange }
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { hasAcceptedCatsCheck, hasAcceptedDogsCheck } = this.props
		const { data, cats_accept_checkbox, dogs_accept_checkbox } = this.state

		if ( ! data ) {
			return null
		}

		const { code, name, image_url, sex, breed, age, shelter_id, adopt_form_id, adopt_form_field_id } = data

		let actionUrl = `https://service.sheltermanager.com/asmservice?account=${shelter_id}&method=online_form_html&formid=${adopt_form_id}&${adopt_form_field_id}=${name + ' ' + code}`

		let showCatsCheck = false,
			showDogsCheck = false,
			showButton = true

		if ( 'cat' == data.type ) {
			showCatsCheck = true

			if ( ! cats_accept_checkbox ) {
				showButton = false
			}
		}

		if ( 'dog' == data.type ) {
			showDogsCheck = true

			if ( ! dogs_accept_checkbox ) {
				showButton = false
			}
		}

		return (
			<div className="page-section">
				{ showCatsCheck && this.renderCatsCheck() }
				{ showDogsCheck && this.renderDogsCheck() }

				{ showButton &&
					<a href={ actionUrl } className="adopt-apply-button" target="_blank" rel="noopener">
						<div className="-image-wrap">
							<div className="-image">
								<img src={ image_url } alt={ name } />
							</div>
						</div>

						<div className="-info">
							<div className="-action">
								Continue to Application Form
							</div>

							<div className="-text">
								<h3>{ name } <span>(Tag: { code })</span></h3>

								<p>
									{ sex }, { breed }
									<br />
									{ age }
								</p>
							</div>
						</div>
					</a>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		lastSelectedAnimal: lastSelectedAnimal( state ),
		allPages: state.page.byId,
		hasAcceptedCatsCheck: state.site.hasAcceptedCatsCheck,
		hasAcceptedDogsCheck: state.site.hasAcceptedDogsCheck
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		acceptCatCheck: () => {
			dispatch( acceptCatCheck() )
		},

		acceptDogCheck: () => {
			dispatch( acceptDogCheck() )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( ApplyButton )



// WEBPACK FOOTER //
// ./views/main/page/ApplyButton.jsx